
import React from "react";
import { connect } from "react-redux";
import DashboardList from "../../Components/Layouts/DashboardList";
import { getList, deleteEntityById } from "../../Redux/Reels/actions";
import clean  from "lodash-clean";

function List({ useAuth, getList, list, onDelete}) {
  const tableConfig = {
    title: "Reels",
    filterOptionTitle: "Reels Type",
    filterOptions: [
      "package",
    ],
    defaultFilterValue: 'admin',
    applyFilter: false,
    tableColumns: [
      {name: "Title", selector: 'caption', width: '77%'},
      {name: "Status", selector: 'publish_status', width: '3%'},
      {name: "Order", selector: 'order', width: '3%'},
      {name: "Modified Date", selector: 'updated_at', width: '15%'},
      {name: "ID", selector: 'id', width: '5%'}
    ],
    filterByColumn: 'caption',
    searchByColumn: 'caption',
    updatePath: "/reel/update", 
    addPath: "/reel/add",
    noDataMessage: "No reel exists",
    updateLinkColumn: 'caption',
    deleteBtnText: 'Delete',
    deleteItemsByIdList: (idList) => {
      onDelete(idList)
    },
  }

  return (
    <DashboardList
      useAuth={useAuth}
      getList={getList}
      dataToList={clean(list)}
      tableConfig={tableConfig}
    />
  );
}

const mapStateToProps = (state) => {
  return {
    list: state.reel,  
    loginData: state.loginData, 
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getList: (tokenData) => dispatch(getList(tokenData)),
    onDelete: (idList) => dispatch(deleteEntityById(idList))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(List);
